<script>
import SideMenuItem from '../side-menu-item';

export default {
  name  : 'side-menu-item-approach-about-review-ranking',
  mixins: [SideMenuItem],
  data  : function() {
    return {
      label    : 'クチコミ・ランキングに関する取り組み',
      link     : 'https://s.cosme.net/static/sng/review.html',
      analytics: this.$parent.analytics,
    };
  },
};
</script>
